// extracted by mini-css-extract-plugin
module.exports = {"wrapper":"styles_wrapper__2ibx7","content":"styles_content__2Q6U9","header":"styles_header__1pQgM","description":"styles_description__3NCSL","footer":"styles_footer__1jCrk"};